import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { PlacementService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  providers:[PlacementService,AppGlobals,MasterService]
})
export class CompanyComponent implements OnInit {
  arrcanlst=[];
  objcop:any={};
  oprtype="";
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  constructor(private http: HttpClient, private mservice:MasterService,private pservice: PlacementService,private modalService: NgbModal,private apglobal:AppGlobals) 
  { }

  ngOnInit(): void {
    this.getcomplist();
  }


  getcomplist() {
    this.pservice.getcompanies()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrcanlst = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  opendlgpost(content,formdata,cmd) {
    console.log("formdata",formdata);
    
  
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objcop={};
         this.objcop.oprtype=cmd;
      this.objcop.cpid=0;
      this.objcop.cpnm="";
      
      
    }
    else if (cmd=='update')
    {
      //this.getstudentdata('s_id',formdata)
      this.objcop=formdata;
      this.objcop.oprtype=cmd;
  
    }
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     }
    this.modalRef=this.modalService.open(content,this.modalOptions);
   
     this.modalRef.result.then((result) => {
    
          
       }, (reason) => {
           
       });
      
    
  }
  

  savecompany(objjob)
{
  debugger;

 
  console.log(JSON.stringify(objjob));
  

  this.pservice.save_placompany(objjob)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      if(result.status=='success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.getcomplist();
//this.getstudents('s',0);

}
      //this.alertmessage=result.message;
  
 // this.Getclasslist();
  }, error => 
  alert('error in connection')

  
  //this.alertmessage='error in connection'
  );

}


}
